// extracted by mini-css-extract-plugin
var _1 = "PortalsFieldCheckbox-modulePortalsFieldCheckbox__RREIu";
export { _1 as "PortalsFieldCheckbox" }
